<div class="background">
  <div class="container">
    <div class="headerWrapper" style="display: flex">
      <div class="leftWrapper">
        <a [routerLink]="buildBackLink()">
          <img class="logo" src="./assets/svg/eservice_start-up_portal_positiv.svg" alt="" />
          <img class="logo" src="./assets/svg/Voila_Logo_typo_RGB_2022_negativ.svg" alt="" />
        </a>
        <a class="socialMediaIcon" href="https://instagram.com/voila_startups" target="_blank" rel="noopener"
          ><em class="fab fa-2x fa-instagram" style="font-size: 30px"></em
        ></a>
        <a class="socialMediaIcon" href="https://www.linkedin.com/showcase/voil%C3%A0-die-start-up-arena" target="_blank" rel="noopener">
          <em class="fab fa-2x fa-linkedin" style="font-size: 30px; margin-left: -0.5vw"></em>
        </a>
      </div>
      <div class="rightWrapper">
        <div *ngIf="environmentIsNotProd()" class="flex-centered staging-info">
          <span>Testumgebung</span>
        </div>
        <div class="logoutButton" *ngIf="isLoggedIn(); else loginButton">
          <markant-button fill="solid" colorScheme="primary" (click)="logout()"> Logout </markant-button>
        </div>
        <ng-template #loginButton>
          <div class="logoutButton">
            <markant-button fill="outline" colorScheme="light" [class.disabled]="isIE()" [routerLink]="isIE() ? null : loginRoute">Login</markant-button>
            <markant-button [routerLink]="signupRoute">Registrieren</markant-button>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
